import React from "react"
import { Box, Chip, Tooltip, Typography } from "@mui/material"

const valueCell = ({ cell }) => cell.getValue() ?? "—"
export const statusLabel = (status) => status === "UPLOAD_NEW_APK" ? "New APK uploaded" :
  status ? String(status).replace(/_/g, " ").toLowerCase().replace(/^./, (letter) => letter.toUpperCase()) : "Not reported"

export const applicationColumns = () => [
  {
    accessorKey: "appName", header: "Application", size: 360,
    Cell: ({ row, cell }) => <Box sx={{ minWidth: 0 }}>
      <Tooltip title={cell.getValue() || "Unnamed application"}>
        <Typography variant="body2" fontWeight={600} sx={{ overflowWrap: "anywhere", display: "-webkit-box", WebkitLineClamp: 2, WebkitBoxOrient: "vertical", overflow: "hidden" }}>{cell.getValue() || "Unnamed application"}</Typography>
      </Tooltip>
      <Typography variant="caption" color="text.secondary" sx={{ display: "block", overflowWrap: "anywhere" }}>{row.original.appId || "Package name not reported"}</Typography>
    </Box>,
  },
  // { accessorKey: "applicationId", header: "Application ID", size: 135, Cell: valueCell },
  { accessorKey: "appId", header: "Package name", size: 280, Cell: valueCell },
  { accessorKey: "appVersion", header: "Version", size: 220, Cell: ({ cell }) => <Typography variant="body2" sx={{ overflowWrap: "anywhere" }}>{cell.getValue() ?? "—"}</Typography> },
  { accessorKey: "versionCode", header: "Version code", size: 130, Cell: valueCell },
  { accessorKey: "orgCode", header: "Organization code", size: 160, Cell: valueCell },
  { accessorKey: "status", header: "Upload status", size: 180,
    Cell: ({ cell }) => <Chip size="small" variant="outlined" color={cell.getValue() === "UPLOAD_NEW_APK" ? "info" : "default"} label={statusLabel(cell.getValue())} /> },
  { id: "totTerminals", accessorFn: (row) => row.appSummaryDtl?.totTerminals ?? row.totTerminals, header: "Total terminals", size: 140, Cell: valueCell },
  { id: "totInstallCount", accessorFn: (row) => row.appSummaryDtl?.totInstallCount ?? row.totInstallCount, header: "Installations", size: 130,
    Cell: ({ cell }) => <Chip size="small" variant="outlined" label={cell.getValue() ?? "Not reported"} color={Number(cell.getValue()) > 0 ? "success" : "default"} /> },
  { accessorKey: "totDownld", header: "Downloads", size: 120, Cell: valueCell },
  { accessorKey: "uploadOn", header: "Uploaded", size: 220, enableSorting: false, Cell: valueCell },
  { accessorKey: "createdDateTime", header: "Created", size: 220, enableSorting: false, Cell: valueCell },
  { accessorKey: "description", header: "Description", size: 240,
    Cell: ({ cell }) => <Typography variant="body2" sx={{ overflowWrap: "anywhere" }}>{cell.getValue() || "No description"}</Typography> },
  { accessorKey: "appLogo", header: "Logo available", size: 140,
    Cell: ({ cell }) => cell.getValue() === true ? "Yes" : cell.getValue() === false ? "No" : "Not reported" },
]
